import {
  SocialMediaLinks,
  TARTICLE_PROPS,
  TBreadcrumbTransform,
} from './types';

export const tranformBreadcrumb = (
  articleData: TARTICLE_PROPS
): TBreadcrumbTransform[] => {
  const dataSet = articleData?.breadcrumbs.map((item, index) => {
    if (index === articleData?.breadcrumbs.length - 1) {
      return {
        title: item.term,
        link: null,
      };
    }
    return {
      title: item.term,
      link: `/glossary/${item.SEO_term}`,
    };
  });
  const result = [{ title: 'Home', link: '/glossary' }, ...dataSet];
  return result;
};

export const convertToTitleCase = (str: string): string => {
  const words = str.split('-');

  const titleCaseStr = words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return titleCaseStr;
};

export const transformBreadcrumbKeyword = (
  keyword: string
): TBreadcrumbTransform[] => {
  return [
    {
      title: 'Home',
      link: '/glossary',
    },
    {
      title: keyword,
      link: null,
    },
  ];
};

export const socialIconLink = (slug: string, id: string): string => {
  const links: SocialMediaLinks = {
    whatsapp: `whatsapp://send/?text=https://cleartax.in/g/terms/${slug}?ref=whatsapp-share1`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=https://cleartax.in/g/terms/${slug}?ref=facebook-share`,
    twitter: `https://twitter.com/share?url=https://cleartax.in/g/terms/${slug}?ref=twitter-share`,
    linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=https://cleartax.in/g/terms/${slug}?ref=linkedin-share`,
  };
  return links[id] || '#';
};

export const formateDate = (date: string): string => {
  const lmd = new Date(date);
  const formatedDate = lmd.toLocaleString('en-IN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return formatedDate;
};
